module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-block",
    class: [_vm.classes]
  }, [_c('div', {
    staticClass: "o-block__img"
  }, [_c('img', _vm._b({}, 'img', {
    src: _vm.src,
    alt: _vm.alt
  }, false))]), _vm._v(" "), _c('div', {
    staticClass: "o-block__body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e807f52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Block/Block.vue
// module id = 38
// module chunks = 0